import { TextSkeleton } from 'src/libs/TextSkeleton';
import { TableRowLayout } from '../TableLayout';

export const renderTableBodySkeleton = () =>
  Array(10)
    .fill(undefined)
    .map((_, index) => (
      <TableRowLayout
        key={index}
        manuallyAdded={<TextSkeleton numberOfCharacters={14} />}
        name={<TextSkeleton numberOfCharacters={15} />}
        phoneNumber={<TextSkeleton numberOfCharacters={10} />}
        status={<TextSkeleton numberOfCharacters={10} />}
        mostRecentRole={<TextSkeleton numberOfCharacters={18} />}
        mostRecentCompanyName={<TextSkeleton numberOfCharacters={15} />}
        mostRecentRoleMobile={<TextSkeleton numberOfCharacters={18} />}
        mostRecentApplication={<TextSkeleton numberOfCharacters={18} />}
        relativeApplicationTime={<TextSkeleton numberOfCharacters={9} />}
        previousApplications={<TextSkeleton numberOfCharacters={20} />}
        kebab={<TextSkeleton numberOfCharacters={1} />}
      />
    ));
